var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.541 15.07a7 7 0 0 1 9.9-.02 5.001 5.001 0 0 1 8.052 3.693L22.5 19a1 1 0 0 1-.898.995L16.5 20a1 1 0 0 1-1 1h-12a1 1 0 0 1-.995-.898L2.5 20a7 7 0 0 1 2.041-4.93zM17.5 7a3 3 0 0 1 0 6l-.154-.004a3 3 0 0 1-2.842-2.842L14.5 10a3 3 0 0 1 3-3zm-8-4a4 4 0 0 1 .206 7.995L9.5 11a4 4 0 0 1-3.995-3.794L5.5 7a4 4 0 0 1 4-4z",
    fill: "#939393"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffs);
export default __webpack_public_path__ + "static/media/staffs.5e9987043a9ccb9a1131f8cbffa8246b.svg";
export { ForwardRef as ReactComponent };